import { FC, useCallback, useEffect, useState } from "react";
import {
  CategoryDetailItem,
  ProductCategories,
  ProductCategoryWrap,
  ProductSpin,
} from "./style";
import {
  Button,
  Flex,
  Input,
  Modal,
  Space,
  Tag,
  Tooltip,
  Tree,
  Typography,
  notification,
} from "antd";
import useProductCategory from "./hooks/useCategoryDetail";
import useCategoryAdd from "./hooks/useCategoryAdd";
import {
  CategoryAdd,
  ProductCategory,
  StoreTypeEnum,
} from "@/types/product";
import ModalForm from "@/styles/Form/ModalForm";
import { DataNode } from "antd/es/tree";
import React from "react";
import GLoading from "@/styles/Placeholder/GLoading";
import GEmpty from "@/styles/Placeholder/GEmpty";
import { DeleteTwoTone, DownOutlined, HighlightOutlined, UpOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import useCategories from "./hooks/useCategories";
import useCategoryDelete from "./hooks/useCategoryDelete";
import SText from "@/styles/SText";
import ProductList from "../Product/components/ProductList";
import { useSelector } from "react-redux";
import { RootState } from "@/store/index";
import { User, UserPermissionEnum } from "@/types/user";
import { hasPermission } from "@/utils/user";
import SelectOrgs from "@/components/Selector/SelectOrgs";
import { Org } from "@/types/org";
import ListFilterBar from "@/components/ListFilterBar";
import useCommittedFilters from "@/components/ListFilterBar/hooks/useCommittedFilters";

const { Title, Paragraph, Text } = Typography;
const { confirm } = Modal;
const _ = require("lodash");

interface CategoryFilters {
  keyword: string;
}

const INITIAL_CATEGORY_FILTERS: CategoryFilters = {
  keyword: "",
};

const ProductCategoryView: FC = () => {

  const { t } = useTranslation();
  const [notificationApi, contextHolder] = notification.useNotification({ placement: 'top' });
  const curUser: User = useSelector((state: RootState) => state.userReducer.curUser);

  const cateOrgPermission = hasPermission(curUser, [UserPermissionEnum.PRODUCT_CATEGORY_ORG_SET]);

  const [detail, deLoading, { fetchDetail, updateItem, setItemOrgs, setDetail, setLoading }] =
    useProductCategory();
  const [
    list,
    ,
    loading,
    { addCategory, updateCategory, deleteCategory, searchCategory },
  ] = useCategories({ keyword: "", cateOrgPermission });
  const [{ add }] = useCategoryAdd();
  const [, { del }] = useCategoryDelete();

  const [isAdd, setIsAdd] = useState<boolean>(false);
  const [expanded, setExpanded] = useState(false);
  const [isEditDesc, setIsEditDesc] = useState(false);
  const [treeSelectId, setTreeSelectId] = useState<string>();
  const {
    draftFilters,
    updateDraftFilters,
    commitFilters,
    replaceFilters,
  } = useCommittedFilters<CategoryFilters>(INITIAL_CATEGORY_FILTERS);
  const { keyword } = draftFilters;

  const [addModalTitle, setAddModalTitle] = useState<string>(
    t("category.addCategory")
  );

  // 是否可添加子类目 tip: 共只允许添加3级类目; 1级类目不可操作商品，2/3级可操作商品;
  const [isAddSubCategory, setIsAddSubCategory] = useState<boolean>(true);
  const [isTopCategory, setIsTopCategory] = useState<boolean>(false); // 是否是1级类目; 1级类目固定/不可进行CURD操作。

  useEffect(() => {
    if (list && list.length > 0 && !treeSelectId) onCheckFetch(list[0].id);
  }, [list]);

  useEffect(() => {
    if (detail) {
      setIsAddSubCategory(detail.path.split("#").length < 3);
      setIsTopCategory(detail.path.split("#").length === 1 ? true : false);
    }
  }, [detail]);

  const onCheckFetch = (id: string) => {
    if (id) {
      // setProductKeyword("");
      setTreeSelectId(id);
      fetchDetail(id);
      // fetch(id, "", 0);
    }
  };

  const onAddBut = (val: "add" | "addSub") => {
    setAddModalTitle(
      val === "add" ? t("category.addCategory") : t("category.addSubCategory")
    );
    setIsAdd(true);
  };

  const onDelCategory = () => {
    if (true && [].length > 0) {
      return notificationApi.warning({ message: t("category.noDelTips1") });
    }
    if (detail && detail.id) {
      if (detail.subs && detail.subs.length > 0) {
        notificationApi.warning({ message: t("category.noDelTips2") });
        return;
      }
      confirm({
        title: t("category.tips"),
        content: t("category.conTips"),
        onOk() {
          del(detail.id).then(() => {
            const delList = list.filter((item) => item.id !== detail.id);
            if (!detail.pId && delList.length === 0) {
              setTreeSelectId(undefined);
            } else {
              onCheckFetch(detail.pId || delList[0].id);
            }
          });
          deleteCategory(detail);
        },
      });
    }
  };

  const onSelect = useCallback(
    _.debounce((selectedKeys: string[]) => {
      onCheckFetch(selectedKeys[0]);
    }, 1000),
    []
  );

  const setOrgs = (orgs: Array<Org>) => {
    return new Promise<void>((res, rej) => {
      setItemOrgs(orgs?.map(org => org.id) || [])
        .then(() => {
          notification.success({ placement: 'top', message: t("member.changeStatusSucc") })
          detail && setDetail({
            ...detail,
            orgs
          })
          return res()
        })
        .catch(() => {
          notification.error({ placement: 'top', message: t("member.updateFail") })
          return rej()
        })

    })
  }

  const handleCategorySearch = () => {
    const nextFilters = commitFilters();
    searchCategory(nextFilters.keyword);
  };

  const handleClearCategoryFilters = () => {
    const nextFilters = replaceFilters(INITIAL_CATEGORY_FILTERS);
    searchCategory(nextFilters.keyword);
  };

  const contentWrap = (
    <React.Fragment>
      <ProductCategories className="left">
        <div style={{ marginBottom: 10 }}>
          <ListFilterBar
            onSearch={handleCategorySearch}
            onReset={handleClearCategoryFilters}
            disabled={loading}
          >
            {({ submit }) => (
              <Input
                placeholder={t("category.plEnterName")}
                value={keyword}
                onChange={event => updateDraftFilters({ keyword: event.target.value })}
                onPressEnter={submit}
                style={{ width: 110 }}
              />
            )}
          </ListFilterBar>
        </div>
        {list && list.length > 0 ? (
          <Tree
            selectedKeys={[treeSelectId || ""]}
            onSelect={(val) => {
              if (val && val.length > 0) {
                setLoading(true);
                setTreeSelectId(val[0] as string);
                onSelect(val);
              }
            }}
            blockNode
            titleRender={(data) => (
              <SText text={(data as unknown as { name: string }).name} />
            )}
            treeData={list as unknown as Array<DataNode>}
            fieldNames={{ title: "name", key: "id", children: "subs" }}
            className="left-tree"
          />
        ) : (
          <GEmpty />
        )}
      </ProductCategories>
      <div className="right">
        {deLoading && <ProductSpin />}
        {detail && treeSelectId && !deLoading && (
          <Flex vertical style={{ width: "100%", height: "100%" }}>
            <div>
              {
                isAddSubCategory && hasPermission(curUser, [UserPermissionEnum.PRODUCT_CATEGORY_EDIT_INFO]) && (
                  <Button
                    onClick={() => onAddBut("addSub")}
                    style={{ marginBottom: "10px" }}
                  >
                    {t("category.addSubCategory")}
                  </Button>
                )
              }

              <Title
                level={3}
                editable={
                  isTopCategory || !hasPermission(curUser, [UserPermissionEnum.PRODUCT_CATEGORY_EDIT_INFO])
                    ? false
                    : {
                      maxLength: 100,
                      icon: <HighlightOutlined />,
                      tooltip: t("product.clickModify"),
                      onChange: (value) => {
                        updateItem("name", value);
                        updateCategory({ ...detail, name: value });
                      },
                    }
                }
                style={{ display: "inline" }}
              >
                {detail.name}
              </Title>
              {isTopCategory && cateOrgPermission && <span style={{ display: "inline-block", marginLeft: 6, minWidth: 180 }}>
                <SelectOrgs defaultValues={detail?.orgs?.map(org => org.id)} onConfirm={setOrgs} />
              </span>}
              {!isTopCategory && hasPermission(curUser, [UserPermissionEnum.PRODUCT_CATEGORY_EDIT_INFO]) && (
                <Tooltip title={t("category.delCategory")}>
                  <>
                    <DeleteTwoTone
                      style={{ fontSize: 26, marginLeft: "10px" }}
                      onClick={onDelCategory}
                    />
                    <br />
                  </>
                </Tooltip>
              )}
              <CategoryDetailItem className="category-detail--item">
                <div className="category-detail--item-left">
                  {t("category.storeType")}
                </div>
                <div className="category-detail--item-right">
                  <Tag
                    color={
                      detail?.storeType === StoreTypeEnum.CODE
                        ? "blue"
                        : "green"
                    }
                  >
                    {detail?.storeType === StoreTypeEnum.CODE
                      ? t("category.storeTypeCode")
                      : t("category.storeTypeNum")}
                  </Tag>
                </div>
              </CategoryDetailItem>
              <div style={{ marginTop: "10px" }}>
                {t("category.code")}:<Text code>{detail?.code}</Text>
              </div>
              <Flex>
                <Text>{t("category.hsCode")}:</Text>
                <Text
                  editable={
                    isTopCategory || !hasPermission(curUser, [UserPermissionEnum.PRODUCT_CATEGORY_EDIT_INFO])
                      ? false
                      : {
                        maxLength: 20,
                        icon: <HighlightOutlined />,
                        onChange: (value) => {
                          updateItem("hsCode", value);
                          updateCategory({ ...detail, hsCode: value });
                        },
                      }
                  }
                  style={{ display: "inline" }}
                >
                  {detail.hsCode}
                </Text>
              </Flex>
              <Flex style={{ marginTop: "10px" }}>
                <Text>{t("common.desc")}:</Text>
                <Paragraph
                  ellipsis={{
                    rows: 1,
                    expandable: "collapsible",
                    expanded,
                    onExpand: (_, info) => setExpanded(info.expanded),
                    symbol: (expand) => {
                      if (expand) {
                        return <UpOutlined style={{ fontSize: 12 }} />
                      }
                      return <DownOutlined style={{ fontSize: 12 }} />
                    }
                  }}
                  copyable
                  editable={
                    isTopCategory || !hasPermission(curUser, [UserPermissionEnum.PRODUCT_CATEGORY_EDIT_INFO])
                      ? false
                      : {
                        editing: isEditDesc,
                        maxLength: 1000,
                        autoSize: {
                          minRows: 4,
                          maxRows: 8,
                        },
                        onChange: (value) => {
                          updateItem("desc", value);
                          setIsEditDesc(false);
                        },
                        onStart: () => setIsEditDesc(true),
                      }
                  }
                  style={{ marginLeft: "10px", width: "90%" }}
                >
                  {detail.desc}
                </Paragraph>
              </Flex>
            </div>
            {!isTopCategory && (
              <Flex vertical style={{ width: "100%", flex: 1 }}>
                <ProductList hiddenColumns={['category', 'docId', 'picDocId']} categoryId={treeSelectId} />
                {/* <AddOrEdit
                  isAdd={addProductModal}
                  openStatus={isOpenEdit || addProductModal}
                  formData={isOpenEdit ? editRow : null}
                  categoryId={addProductModal ? treeSelectId : null}
                  onOk={(res) => {
                    if (isOpenEdit) {
                      updateProductItem(res);
                      if (editRow && res.categoryId !== editRow?.categoryId) {
                        rmItem(editRow.id)
                      }
                    } else {
                      res.categoryId === treeSelectId && addProductItem(res);
                    }
                  }}
                  onCancel={() => {
                    if (isOpenEdit) {
                      setIsOpenEdit(false);
                      setEditRow(null);
                    } else {
                      setAddProductModal(false);
                    }
                  }}
                /> */}
              </Flex>
            )}
          </Flex>
        )}
      </div>
      <ModalForm<CategoryAdd, ProductCategory>
        isOpen={isAdd}
        modalTitle={addModalTitle}
        maskClosable={false}
        formName={"categoryAdd"}
        formItems={[
          {
            label: t("category.code"),
            key: "code",
            value: "",
            type: "input",
            // 二级类目code-2位，三级类目code-3位
            maxLength: detail?.code?.length === 2 ? 2 : 3,
            otherProps: {
              placeholder: t("category.plCode"),
              addonBefore: detail?.code,
              count: { show: true, max: detail?.code?.length === 2 ? 2 : 3 },
            },
            rules: [{ required: true, message: t("category.plCode") }],
          },
          {
            label: t("category.name"),
            key: "name",
            value: "",
            type: "input",
            maxLength: 100,
            otherProps: {
              placeholder: t("category.plName"),
              count: { show: true, max: 100 },
            },
            rules: [{ required: true, message: t("category.plName") }],
          },
          {
            label: t("category.hsCode"),
            key: "hsCode",
            value: "",
            type: "input",
            maxLength: 20,
            otherProps: {
              placeholder: t("category.plHsCode"),
              count: { show: true, max: 20 },
            },
          },
          {
            label: t("common.desc"),
            key: "desc",
            value: "",
            type: "textarea",
            maxLength: 1000,
            otherProps: {
              placeholder: t("product.plDesc"),
              autoSize: { minRows: 4, maxRows: 8 },
              count: { show: true, max: 1000 },
            },
          },
        ]}
        handleCancel={() => setIsAdd(false)}
        handleOk={(res) => {
          setIsAdd(false);
          addCategory(res);
          if (treeSelectId) fetchDetail(treeSelectId);
        }}
        okApi={(info: CategoryAdd) => {
          info.code = `${detail?.code}${info.code}`;
          if (treeSelectId && addModalTitle !== t("category.addCategory"))
            info.pId = treeSelectId;
          return add({ ...info });
        }}
      />
    </React.Fragment>
  );

  return (
    <ProductCategoryWrap>
      {contextHolder}
      {loading ? <GLoading /> : contentWrap}
    </ProductCategoryWrap>
  );
};

export default ProductCategoryView;
